import './Blog.scss';
import $ from 'jquery';

var articleListModule = (function () {
    var button = null;
    var list = null;
    var host = window.location.origin + '/';
    var path = 'Blog/GetArticles';
    var offset = 4;
    var count = 4;

    var displayData = function (result) {
        $('.articles-body').append(result);

        offset += count;
        var resultWrapper = document.createElement('div');
        resultWrapper.innerHTML = result;
        var articles = resultWrapper.querySelectorAll('article.article-small');

        if (articles.length === 0) {
            button.addClass('hidden');
            return;
        }

        $.each(articles, function (idx, article) {
            list.append(article);
        });

        if (articles.length < count) {
            button.addClass('hidden');
            return;
        }
    };

    var getMoreArticles = function () {
        var url = host + path + "?offset=" + offset + "&count=" + count;
        $.ajax({
            url: url,
            success: displayData
        });
    };

    // Share buttons
    function facebookShare() {
        var sharerUrl = 'https://www.facebook.com/sharer.php?u=' + encodeURIComponent(document.location);
        window.open(sharerUrl, 'fbshare', 'width=550,height=450,toolbars=no');
    }
    window.facebookShare = facebookShare;

    function twitterShare() {
        var sharerUrl = 'https://twitter.com/share?url=' + encodeURIComponent(document.location);
        window.open(sharerUrl, 'twitter-popup', 'width=550,height=450');
    }
    window.twitterShare = twitterShare;

    function init() {
        button = $('#getMoreArticles');
        list = $('.articles-row-reverse');
        button.click(getMoreArticles);
    }

    return {
        init: init
    }
}());

$(document).ready(articleListModule.init);


// WEBPACK FOOTER //
// ./Src/Blog/Blog.js